import { useState, useEffect } from "react";
import {
  verifyDependent,
  APIGateway } from
"../../../services/rhapsody/ManageDependents";
import OtpVerification from "./OtpVerification";
import {
  handleEmiratesIdChange,
  handlePatientIdChange,
  handleYearChange } from
"../helpers/FormHandlers";
import AlertDependent from "../../../common/AlertDependent";
import { Loader } from "../../../common/Loader";

const AddDependent = ({
  setCurrentPage,
  setDependentList,
  setAlertAddDependent,
  depedentList,
  setAlertAlreadyAdded,
  setAlertDeceasedPatient,
  translationMap
}) => {
  const [, setPatientDetails] = useState({});
  const [alert, setAlert] = useState(false);
  const [patientId, setPatientId] = useState("");
  const [emiratesId, setEmiratesId] = useState("");
  const [, setIsButtonDisabled] = useState(false);
  //for already exist patient (move to dashboard)
  const [errorMessage, setErrorMessage] = useState(false);
  const [showOtp, setShowOtp] = useState(false);

  const [patientYear, setPatientYear] = useState("");
  const [emiratesYear, setEmiratesYear] = useState("");
  const [mrnError, setMrnError] = useState("");
  const [mrnYearError, setMrnYearError] = useState("");
  const [emiratesIdError, setEmiratesIdError] = useState("");
  const [emiratesYearError, setEmiratesYearError] = useState("");
  const [otpBlockError, setOtpBlockError] = useState(false);
  const [mobileNumber, setMobileNumber] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [id, setId] = useState("");
  const [mainUserAlert, setMainUserAlert] = useState(false);


  useEffect(() => {
    setAlertAlreadyAdded(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const disableButton = !(
    patientId ||
    emiratesId ||
    patientYear ||
    emiratesYear);

    setIsButtonDisabled(disableButton);
  }, [patientId, emiratesId, patientYear, emiratesYear]);

  const validateInput = async () => {
    window.parent.scrollTo(0, 0);
    setOtpBlockError(false);
    setAlert(false);
    if (!patientId && !emiratesId) {
      setMrnError(translationMap?.mrnRequired);
      setEmiratesIdError(translationMap?.emiratesIdRequired);
      return;
    }
    if (patientId && !patientYear) {
      setMrnYearError(translationMap?.yearRequired);
      return;
    }
    if (emiratesId && !emiratesYear) {
      setEmiratesYearError(translationMap?.yearRequired);
      return;
    }
    const year = patientId ? patientYear : emiratesYear;
    try {
      setEmiratesYearError("");
      setMrnYearError("");
      const response = await verifyDependent(patientId, emiratesId, year);
      if (response.data.message === "mainDependent")
      {
        setAlert(false);
        setMainUserAlert(true);
        return;
      }
      if (response.data.success) {
        setIsLoading(true);
        const patientInfo = await APIGateway(patientId, emiratesId, year);
        if (patientInfo?.data?.message === "otpBlocked")
        {
          setOtpBlockError(true);
          return;
        }
        setOtpBlockError(false);
        setPatientDetails(patientInfo);
        const mobile = patientInfo?.data?.mobileNumber;
        const idInfo = patientInfo?.data?.encryptJsonData;
        setId(idInfo);
        setMobileNumber(mobile);
        //setIsLoading(false);
        setShowOtp(true);
      } else {
        setMainUserAlert(false);
        setOtpBlockError(false);
        setAlert(true);
      }
    } catch (error) {
      //  console.error("Error verifying dependent:", error);
      return null;
    } finally
    {
      setIsLoading(false);
    }
  };

  const handleBack = () => {
    window.parent.scrollTo(0, 0);
    setAlertAlreadyAdded(false);
    setCurrentPage("home");
    setAlertAddDependent(false);
  };

  if (isLoading)
  {
    return (
      <Loader />);

  }

  return (
    <>
      <section
        className="w-100 clearfix ManageDependentMainSection"
        id="CoverPlanActive">
        
        <div className="container customContainer">
          <div className="Title_Inner_Box">
            <h6 className="MainTitleOne">{translationMap?.addDependent}</h6>
          </div>

          <div className="cover_inner_wrapper cover_inner_wrapper2">
            <div className="cover_main_box1">
              {alert &&
              <AlertDependent
                setError={setAlert}
                alert_text={translationMap?.patientNotFound}
                number_text={translationMap?.patientNotFoundText} />

              }

              {mainUserAlert &&
              <AlertDependent
                setError={setMainUserAlert}
                alert_text={translationMap?.mainUserAlertText || "Please do not use the health card number of the current user"} />

              }

              {otpBlockError &&
              <AlertDependent
                setError={setOtpBlockError}
                alert_text={
                translationMap?.otpBlocked ||
                "OTP blocked due to multiple incorrect attempts. Try again after 5 minutes."
                } />

              }

              {errorMessage &&
              <AlertDependent
                setError={setErrorMessage}
                alert_text={
                translationMap?.patientAlreadyExist ||
                "Patient Already Exist"
                } />

              }
              <div className="top_title_box">
                <h6 className="Gray_Title">
                  {translationMap?.addDependentUsingMrn}
                </h6>
              </div>
              <div className="dependent_form_box">
                <form>
                  <div className="form_inner_box">
                    <div className="inner_input_box">
                      <div className="input_box">
                        <label>{translationMap?.mrn}</label>
                        <div className="input_wrap">
                          <input
                            type="text"
                            name="number"
                            inputmode="numeric"
                            placeholder={translationMap?.typeDependentMrn}
                            value={patientId}
                            onChange={(e) =>
                            handlePatientIdChange(
                              e,
                              setPatientId,
                              setEmiratesId,
                              setEmiratesYear,
                              setMrnError,
                              setEmiratesIdError,
                              translationMap
                            )
                            }
                            // disabled={emiratesId}
                            style={{
                              borderColor: mrnError ?
                              "#FF8F8A" :
                              "rgb(128 153 178)"
                            }} />
                          
                          {mrnError &&
                          <span id="text" style={{ color: "#FF8F8A" }}>
                              {mrnError}
                            </span>
                          }
                        </div>
                      </div>
                    </div>
                    <div className="inner_input_box">
                      <div className="input_box">
                        <label>{translationMap?.yearOfBirth}</label>
                        <div className="input_wrap input-group">
                        <input
                            type="string"
                            name="date"
                            value={patientYear}
                            inputmode="numeric"
                            onChange={(e) =>
                            handleYearChange(
                              e,
                              setPatientYear,
                              setMrnYearError,
                              translationMap
                            )
                            }
                            //disabled={!patientId}
                            // disabled = {emiratesId}
                            placeholder={translationMap?.yearOfBirth}
                            style={{
                              borderColor: mrnYearError ? "#FF8F8A" : "#CCCCCC"
                            }} />
                          
                          {mrnYearError &&
                          <span id="text" style={{ color: "#FF8F8A" }}>
                              {mrnYearError}
                            </span>
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="form_inner_box">
                    <div className="form_title">
                      <h6 className="Gray_Title">
                        {translationMap?.addDependentUsingEmiratesId}
                      </h6>
                    </div>
                  </div>
                  <div className="form_inner_box">
                    <div className="inner_input_box">
                      <div className="input_box">
                        <label>{translationMap?.emiratesId}</label>
                        <div className="input_wrap">
                          <input
                            type="text"
                            name="number"
                            inputmode="numeric"
                            placeholder={translationMap?.typeYourEmiratesId}
                            value={emiratesId}
                            onChange={(e) =>
                            handleEmiratesIdChange(
                              e,
                              setEmiratesId,
                              setPatientId,
                              setPatientYear,
                              setEmiratesIdError,
                              setMrnError,
                              translationMap
                            )
                            }
                            // disabled={patientId}
                            style={{
                              borderColor: emiratesIdError ?
                              "#FF8F8A" :
                              "rgb(128 153 178)"
                            }} />
                          
                          {emiratesIdError &&
                          <span id="text" style={{ color: "#FF8F8A" }}>
                              {emiratesIdError}
                            </span>
                          }
                        </div>
                      </div>
                    </div>
                    <div className="inner_input_box">
                      <div className="input_box">
                        <label>{translationMap?.yearOfBirth}</label>
                        <div className="input_wrap input-group">
                        <input
                            type="string"
                            name="date"
                            value={emiratesYear}
                            inputmode="numeric"
                            onChange={(e) =>
                            handleYearChange(
                              e,
                              setEmiratesYear,
                              setEmiratesYearError,
                              translationMap
                            )
                            }
                            // disabled={patientId}
                            placeholder={translationMap?.yearOfBirth}
                            style={{
                              borderColor: emiratesYearError ?
                              "#FF8F8A" :
                              "#CCCCCC"
                            }} />
                          
                          {emiratesYearError &&
                          <span id="text" style={{ color: "#FF8F8A" }}>
                              {emiratesYearError}
                            </span>
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="form_btn_box">
                    {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                    <a className="blue_btn_link" onClick={validateInput}>
                      {translationMap?.addDependent}
                    </a>
                    {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                    <a className="bluetrans_btn_link" onClick={handleBack}>
                      {translationMap?.backToManageDependent}
                    </a>
                  </div>
                </form>
              </div>
            </div>
            <div className="cover_main_box2"></div>
          </div>
        </div>
      </section>

      {showOtp &&
      <OtpVerification
        setShowOtp={setShowOtp}
        setAlertAddDependent={setAlertAddDependent}
        setCurrentPage={setCurrentPage}
        setDependentList={setDependentList}
        patientId={patientId}
        patientYear={patientYear}
        emiratesId={emiratesId}
        emiratesYear={emiratesYear}
        setAlertAlreadyAdded={setAlertAlreadyAdded}
        depedentList={depedentList}
        mobileNumber={mobileNumber}
        id={id}
        setAlertDeceasedPatient={setAlertDeceasedPatient}
        translationMap={translationMap} />

      }
    </>);

};

export default AddDependent;